import React from 'react';
import './VisualizationCard.css';

interface ShareBucket {
  label: string;
  count: number;
}

interface ActiveSharesCardProps {
  shareBuckets: ShareBucket[];
  totalShares: number;
  sharesUsed: number;
  sharesLimit: number;
}

const ActiveSharesCard: React.FC<ActiveSharesCardProps> = ({ shareBuckets, totalShares, sharesUsed, sharesLimit }) => {
  const maxCount = shareBuckets.length > 0 ? Math.max(...shareBuckets.map(b => b.count), 1) : 1;
  const quotaPercent = sharesLimit > 0 ? Math.min((sharesUsed / sharesLimit) * 100, 100) : 0;
  const atLimit = sharesLimit > 0 && sharesUsed >= sharesLimit;

  return (
    <div className="visualization-card">
      <h3 className="card-title">Active Shares</h3>

      {sharesLimit > 0 && (
        <div style={{ marginBottom: '0.75rem' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.78rem', color: atLimit ? '#dc2626' : '#666', marginBottom: '4px' }}>
            <span>Monthly quota</span>
            <span style={{ fontWeight: 600 }}>{sharesUsed} / {sharesLimit}</span>
          </div>
          <div style={{ width: '100%', height: '6px', background: '#e5e7eb', borderRadius: '4px', overflow: 'hidden' }}>
            <div style={{ height: '100%', width: `${quotaPercent}%`, background: atLimit ? '#dc2626' : 'linear-gradient(90deg, #667eea, #764ba2)', borderRadius: '4px', transition: 'width 0.3s ease' }} />
          </div>
          {atLimit && <div style={{ fontSize: '0.72rem', color: '#dc2626', marginTop: '3px' }}>Monthly limit reached — resets next month</div>}
        </div>
      )}

      <div className="card-content" style={{ justifyContent: 'flex-start' }}>
        {totalShares === 0 ? (
          <div className="no-data-message">No active shares</div>
        ) : (
          <>
            <div style={{ fontSize: '0.8rem', color: '#666', marginBottom: '0.75rem' }}>
              {totalShares} total active share{totalShares !== 1 ? 's' : ''}
            </div>
            <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>
              {shareBuckets.map(bucket => (
                <div key={bucket.label} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                  <div style={{ width: '52px', fontSize: '0.78rem', color: '#666', textAlign: 'right', flexShrink: 0 }}>
                    {bucket.label}
                  </div>
                  <div style={{ flex: 1, height: '20px', background: '#f3f4f6', borderRadius: '4px', overflow: 'hidden' }}>
                    <div style={{
                      height: '100%',
                      width: `${(bucket.count / maxCount) * 100}%`,
                      background: 'linear-gradient(90deg, #667eea, #764ba2)',
                      borderRadius: '4px',
                      transition: 'width 0.3s ease',
                      minWidth: bucket.count > 0 ? '4px' : '0',
                    }} />
                  </div>
                  <div style={{ width: '24px', fontSize: '0.82rem', fontWeight: 600, color: '#333', textAlign: 'right', flexShrink: 0 }}>
                    {bucket.count}
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ActiveSharesCard;
